window.tsnejs = require('../lib/index.js');



//////////////////
// WEBPACK FOOTER
// ./dist/index.js
// module id = 0
// module chunks = 0